import { render, staticRenderFns } from "./Primary_data.vue?vue&type=template&id=cfd62b16&"
import script from "./Primary_data.vue?vue&type=script&lang=js&"
export * from "./Primary_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports